'use strict';

var React = require('react');

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');

var classNames = require('classnames');

var _extends = require('@babel/runtime/helpers/extends');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var reactFontawesome = require('@fortawesome/react-fontawesome');

var faCaretDown = require('@fortawesome/pro-solid-svg-icons/faCaretDown');

var subscriptions = require('pobble-components/dist/subscriptions');

var jssMixins = require('pobble-components/dist/jss-mixins');

var pobbleAvatar = require('pobble-components/dist/pobble-avatar');

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var _inherits = require('@babel/runtime/helpers/inherits');

var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');

var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');

var api = require('pobble-components/dist/api');

var Button = require('pobble-components/dist/button');

var faBell = require('@fortawesome/pro-regular-svg-icons/faBell');

var faCrown = require('@fortawesome/pro-solid-svg-icons/faCrown');

var pobbleUser = require('pobble-components/dist/pobble-user');

var faChalkboard = require('@fortawesome/pro-solid-svg-icons/faChalkboard');

var faSchool = require('@fortawesome/pro-solid-svg-icons/faSchool');

var faGlobe = require('@fortawesome/pro-solid-svg-icons/faGlobe');

var faSignOut = require('@fortawesome/pro-solid-svg-icons/faSignOut');

var faUser = require('@fortawesome/pro-solid-svg-icons/faUser');

var faFeather = require('@fortawesome/pro-solid-svg-icons/faFeather');

var faFileCheck = require('@fortawesome/pro-solid-svg-icons/faFileCheck');

var faLightbulbOn = require('@fortawesome/pro-solid-svg-icons/faLightbulbOn');

var faSearch = require('@fortawesome/pro-solid-svg-icons/faSearch');

var setup = require('pobble-components/dist/setup');

var PropTypes = require('prop-types');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var _slicedToArray__default =
/*#__PURE__*/
_interopDefaultLegacy(_slicedToArray);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var _inherits__default =
/*#__PURE__*/
_interopDefaultLegacy(_inherits);

var _possibleConstructorReturn__default =
/*#__PURE__*/
_interopDefaultLegacy(_possibleConstructorReturn);

var _getPrototypeOf__default =
/*#__PURE__*/
_interopDefaultLegacy(_getPrototypeOf);

var Button__default =
/*#__PURE__*/
_interopDefaultLegacy(Button);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var BREAKPOINTS$1 = THEME__default["default"].BREAKPOINTS;
var styles$6 = {
  '@keyframes fadeIn': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  container: _defineProperty__default["default"]({
    position: 'relative',
    zIndex: '100',
    boxSizing: 'border-box',
    '& *': {
      boxSizing: 'border-box'
    },
    fontSize: '14px',
    lineHeight: '17px',
    height: '70px',
    color: '#fff',
    background: "var(--blue)",
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }, "@media (max-width: ".concat(BREAKPOINTS$1.SM, ")"), {
    height: '50px',
    padding: '5px 10px'
  }),
  studentHeader: {
    background: "var(--green)"
  },
  logo: _defineProperty__default["default"]({
    width: '82px',
    height: '42px'
  }, "@media (max-width: ".concat(BREAKPOINTS$1.SM, ")"), {
    width: '60px',
    height: '100%'
  }),
  logoIcon: {
    width: '100%',
    height: '100%'
  },
  nav: {
    animation: 'fadeIn 0.3s',
    display: 'flex',
    height: '100%',
    alignItems: 'center'
  }
};
var BREAKPOINTS = THEME__default["default"].BREAKPOINTS;
var styles$5 = {
  menuHolder: _defineProperty__default["default"]({}, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    background: '#fff',
    transition: 'transform 0.3s, opacity 0.3s',
    transform: 'translate3d(320px, 0, 0)',
    opacity: '0',
    pointerEvents: 'none',
    width: '320px',
    height: 'calc(100vh - 50px)',
    position: 'fixed',
    top: '50px',
    right: '0',
    padding: '20px 30px 120px'
  }),
  menuHolderOpened: _defineProperty__default["default"]({}, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    pointerEvents: 'auto',
    transform: 'translate3d(0, 0, 0)',
    opacity: '1',
    overflow: 'auto'
  }),
  list: _defineProperty__default["default"]({
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex'
  }, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    flexDirection: 'column',
    padding: '0 0 20px',
    borderBottom: '1px solid #ececec'
  }),
  toggleMobileMenu: _defineProperty__default["default"]({
    display: 'none',
    cursor: 'pointer'
  }, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    display: 'block'
  }),
  mobileOverlay: _defineProperty__default["default"]({
    display: 'none',
    transition: 'opacity 0.3s',
    opacity: '0',
    pointerEvents: 'none',
    position: 'fixed',
    height: 'calc(100vh - 50px)',
    width: '100%',
    left: '0',
    top: '50px',
    background: 'rgba(0, 0, 0, 0.3)'
  }, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    display: 'block'
  }),
  mobileOverlayShown: _defineProperty__default["default"]({}, "@media (max-width: ".concat(BREAKPOINTS.SM, ")"), {
    opacity: '1',
    pointerEvents: 'auto'
  })
};
var styles$4 = {
  burgerButton: {
    width: '12px',
    height: '10px',
    position: 'relative',
    display: 'inline-block'
  },
  bar: {
    transition: 'transform 0.3s, opacity 0.3s',
    background: '#fff',
    height: '2px',
    width: '100%',
    position: 'absolute',
    left: '0',
    top: '4px',
    '&:first-child': {
      top: '0'
    },
    '&:last-child': {
      top: '8px'
    }
  },
  opened: {
    opacity: '0',
    '&:first-child': {
      opacity: '1',
      transform: 'rotate(45deg) translate3d(3px, 3px, 0)'
    },
    '&:last-child': {
      opacity: '1',
      transform: 'rotate(-45deg) translate3d(2.8px, -2.8px, 0)'
    }
  }
};

var BurgerButton = function BurgerButton(_ref) {
  var classes = _ref.classes,
      _ref$opened = _ref.opened,
      opened = _ref$opened === void 0 ? true : _ref$opened;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classes.burgerButton
    },
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classNames__default["default"](classes.bar, _defineProperty__default["default"]({}, classes.opened, opened))
    }),
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classNames__default["default"](classes.bar, _defineProperty__default["default"]({}, classes.opened, opened))
    }),
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classNames__default["default"](classes.bar, _defineProperty__default["default"]({}, classes.opened, opened))
    }))
  );
};

var BurgerButton$1 = injectSheet__default["default"](styles$4)(BurgerButton);
var HeaderContext =
/*#__PURE__*/
React.createContext(null);
var _excluded = ["classes", "className", "linkClassName", "icon", "children", "url", "active", "onClick", "expandable", "subscriptionPolicy"];
var NavItem = injectSheet__default["default"]({
  listItem: {
    '@media (min-width: 769px)': {
      marginLeft: '0'
    }
  },
  nonExpandable: {
    '@media (max-width: 768px)': {
      padding: '24px 0',
      borderBottom: '1px solid #ececec'
    }
  },
  navLink: {
    color: 'var(--gray)',
    fontWeight: 'bold',
    '& *': {
      pointerEvents: 'none'
    },
    '@media (min-width: 769px)': {
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      height: '70px',
      verticalAlign: 'top',
      fontSize: '14px',
      lineHeight: '14px',
      color: '#fff !important',
      transition: 'color 0.3s',
      padding: '16px',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.1)'
      }
    }
  },
  icon: {
    display: 'none',
    marginRight: '8px',
    opacity: '.7',
    '@media (min-width: 769px)': {
      display: 'block'
    }
  },
  expandIcon: {
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'inline-block',
      fontSize: '.8em',
      marginLeft: '.5em',
      marginBottom: '.3em'
    }
  },
  activeLink: {
    '@media (min-width: 769px)': {
      background: 'rgba(0, 0, 0, 0.05)',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.05)'
      }
    }
  }
})(function (_ref) {
  var _classNames2;

  var classes = _ref.classes,
      className = _ref.className,
      linkClassName = _ref.linkClassName,
      icon = _ref.icon,
      children = _ref.children,
      url = _ref.url,
      active = _ref.active,
      onClick = _ref.onClick,
      expandable = _ref.expandable,
      _ref$subscriptionPoli = _ref.subscriptionPolicy,
      subscriptionPolicy = _ref$subscriptionPoli === void 0 ? function () {
    return {
      restricted: false,
      plan: 'pobble-bronze'
    };
  } : _ref$subscriptionPoli,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  var _useContext = React.useContext(HeaderContext),
      me = _useContext.me,
      student = _useContext.student;

  var SP = subscriptions.useSubscriptionPolicy(subscriptionPolicy);
  onClick = !subscriptionPolicy ? onClick : function (e) {
    if (SP.restricted) {
      e.preventDefault();
      SP.showDialog();
    }
  };
  return (
    /*#__PURE__*/
    React__default["default"].createElement("li", {
      className: classNames__default["default"](classes.listItem, _defineProperty__default["default"]({}, classes.nonExpandable, !expandable), className)
    },
    /*#__PURE__*/
    React__default["default"].createElement("a", _extends__default["default"]({
      className: classNames__default["default"](classes.navLink, linkClassName, (_classNames2 = {}, _defineProperty__default["default"](_classNames2, classes.activeLink, active), _defineProperty__default["default"](_classNames2, classes.studentNavLink, student || me && me.account && me.account.student_type), _classNames2)),
      href: url,
      onClick: onClick
    }, props), icon &&
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classes.icon
    }, icon),
    /*#__PURE__*/
    React__default["default"].createElement("span", null, children), expandable &&
    /*#__PURE__*/
    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      className: classes.expandIcon,
      icon: faCaretDown.faCaretDown
    })))
  );
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles$3 = {
  profileCircles: {},
  avatar: _objectSpread({
    width: '40px',
    height: '40px',
    borderRadius: '40px',
    cursor: 'pointer',
    position: 'relative'
  }, jssMixins.hover({
    '& $profileCircles > div': {
      '&:nth-child(1)': {
        transform: 'scale(1.4)'
      },
      '&:nth-child(2)': {
        transform: 'scale(2.2)',
        transitionDelay: '0.1s'
      },
      '&:nth-child(3)': {
        transform: 'scale(3.2)',
        transitionDelay: '0.2s'
      },
      '&:nth-child(4)': {
        transform: 'scale(4.2)',
        transitionDelay: '0.3s'
      }
    }
  })),
  pobbleAvatar: {
    fontSize: '40px',
    zIndex: '60',
    position: 'relative'
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    position: 'relative',
    zIndex: '100'
  },
  profileCircle: {
    pointerEvents: 'none',
    transition: 'transform 1000ms cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    width: '40px',
    height: '40px',
    borderRadius: '40px',
    backgroundColor: 'rgba(255,255,255,0.1)',
    position: 'absolute',
    left: '0',
    top: '0',
    zIndex: '50'
  }
};

var Avatar = function Avatar(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      circles = _ref.circles;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.avatar, className)
    },
    /*#__PURE__*/
    React__default["default"].createElement(pobbleAvatar.MyAvatar, {
      className: classes.pobbleAvatar
    }), circles &&
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.profileCircles
    },
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.profileCircle
    }),
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.profileCircle
    }),
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.profileCircle
    }),
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.profileCircle
    })))
  );
};

var Avatar$1 = injectSheet__default["default"](styles$3)(Avatar);
var DropMenu = injectSheet__default["default"]({
  container: {
    position: 'relative',
    '@media (max-width: 768px)': {
      padding: '24px 0',
      borderBottom: '1px solid #ececec',
      '&:first-child': {
        paddingTop: '0'
      }
    },
    '&:hover': {
      '& $menu': {
        '@media (min-width: 769px)': {
          visibility: 'visible',
          transform: 'translate3d(0, 0, 0)',
          opacity: '1'
        }
      }
    }
  },
  menu: {
    '@media (min-width: 769px)': {
      visibility: 'hidden',
      transition: '.2s cubic-bezier(0,0,0,1)',
      transform: 'translate3d(0, 5px, 0)',
      opacity: '0',
      position: 'absolute',
      right: '0',
      paddingTop: '10px',
      '& > div': {
        minWidth: '180px',
        color: '#a9afbd',
        fontSize: '12px',
        boxShadow: '0 5px 15px 0 rgba(0,0,0,0.15)',
        marginTop: '0',
        background: '#fff',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
        marginRight: '4px'
      },
      '&:after': {
        border: 'solid transparent',
        borderColor: 'rgba(136,183,213,0)',
        borderBottomColor: '#fff',
        borderWidth: '7px',
        bottom: '100%',
        content: '""',
        height: '0',
        marginLeft: '-7px',
        position: 'absolute',
        pointerEvents: 'none',
        right: '10px',
        top: '-4px',
        width: '0'
      }
    }
  },
  headerBox: {}
})(function (_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return children(function (_ref2) {
    var children = _ref2.children,
        className = _ref2.className;
    return (
      /*#__PURE__*/
      React__default["default"].createElement("div", {
        className: classNames__default["default"](classes.container, className)
      }, children)
    );
  }, function (_ref3) {
    var children = _ref3.children,
        className = _ref3.className;
    return (
      /*#__PURE__*/
      React__default["default"].createElement("div", {
        className: classNames__default["default"](classes.menu, className)
      },
      /*#__PURE__*/
      React__default["default"].createElement("div", null, children))
    );
  });
});
var styles$2 = {
  container: {
    fontSize: '16px',
    color: '#666',
    borderBottom: '1px solid #ececec',
    padding: '20px',
    marginBottom: '10px'
  }
};

var ActivityHeader = function ActivityHeader(_ref) {
  var classes = _ref.classes,
      count = _ref.count;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.container
    }, count, " new notification", count > 1 ? 's' : '')
  );
};

var ActivityHeader$1 = injectSheet__default["default"](styles$2)(ActivityHeader);
var styles$1 = {};

var ActivityAction = function ActivityAction(_ref) {
  var classes = _ref.classes,
      activity = _ref.activity;
  var actor = activity && activity.originator.display_name;
  var actions = {
    CommentApproved: activity.activity_type === 'CommentApproved' && "".concat(actor, " commented on ").concat(activity.activity_object.work.title, " by ").concat(activity.activity_object.work.author.display_name),
    WorkPublished: activity.activity_type === 'WorkPublished' && "".concat(actor, " posted ").concat(activity.activity_object.title, " by ").concat(activity.activity_object.author.display_name),
    SchoolFollowed: activity.activity_type === 'SchoolFollowed' && "".concat(actor, " started following ").concat(activity.activity_object.title),
    SchoolUnfollowed: activity.activity_type === 'SchoolUnfollowed' && "".concat(actor, " unfollowed ").concat(activity.activity_object.title),
    PresentationShared: activity.activity_type === 'PresentationShared' && "".concat(actor, " shared a lesson \"").concat(activity.activity_object.presentation.title, "\" with you"),
    ParentAddedToStudent: activity.activity_type === 'ParentAddedToStudent' && "You are now registred as a parent of ".concat(activity.activity_object.display_name),
    GuestModeratorInvited: activity.activity_type === 'GuestModeratorInvited' && "".concat(actor, " invited you to moderate an assessment file"),
    ContributionMarkedAsConclusion: activity.activity_type === 'ContributionMarkedAsConclusion' && "".concat(actor, " has selected a conclusion to an assessment file you contributed to"),
    PaPresentationActionCreated: activity.activity_type === 'PaPresentationActionCreated' && "".concat(actor, " has shared a lesson with you"),
    WorkSubmittedByStudent: activity.activity_type === 'WorkSubmittedByStudent' && "".concat(actor, " sent you work to mark"),
    WorkApprovedByTeacher: activity.activity_type === 'WorkApprovedByTeacher' && "".concat(actor, " approved your work"),
    WorkReturnedByTeacher: activity.activity_type === 'WorkReturnedByTeacher' && "".concat(actor, " asked you to review your work"),
    WorkSentToPeer: activity.activity_type === 'WorkSentToPeer' && "".concat(actor, " sent you work for review"),
    WorkSentBackFromPeer: activity.activity_type === 'WorkSentBackFromPeer' && "".concat(actor, " sent you work for review")
  };
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.container
    }, actions[activity.activity_type] || '')
  );
};

var ActivityAction$1 = injectSheet__default["default"](styles$1)(ActivityAction);
var COLORS = THEME__default["default"].COLORS;
var styles = {
  container: {
    whiteSpace: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    padding: '10px 20px',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    textDecoration: 'none',
    '& em': {
      color: '#666',
      fontStyle: 'normal',
      transition: '300ms ease-in-out'
    },
    '&:hover em': {
      color: COLORS.BLUE.NORMAL
    }
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'normal'
  },
  avatar: {
    fontSize: '24px',
    marginRight: '14px',
    flexShrink: 0
  },
  timestamp: {
    color: '#a8a8a8',
    textAlign: 'right',
    width: '110px'
  }
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

var getTimezoneOffsetInMilliseconds$1 = function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE$1;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE$1 + millisecondsPartOfTimezoneOffset;
};
/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */


function isDate$1(argument) {
  return argument instanceof Date;
}

var is_date = isDate$1;
var getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds$1;
var isDate = is_date;
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var parseTokenDateTimeDelimeter = /[T ]/;
var parseTokenPlainTime = /:/; // year tokens

var parseTokenYY = /^(\d{2})$/;
var parseTokensYYY = [/^([+-]\d{2})$/, // 0 additional digits
/^([+-]\d{3})$/, // 1 additional digit
/^([+-]\d{4})$/ // 2 additional digits
];
var parseTokenYYYY = /^(\d{4})/;
var parseTokensYYYYY = [/^([+-]\d{4})/, // 0 additional digits
/^([+-]\d{5})/, // 1 additional digit
/^([+-]\d{6})/ // 2 additional digits
]; // date tokens

var parseTokenMM = /^-(\d{2})$/;
var parseTokenDDD = /^-?(\d{3})$/;
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
var parseTokenWww = /^-?W(\d{2})$/;
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/; // time tokens

var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/; // timezone tokens

var parseTokenTimezone = /([Z+-].*)$/;
var parseTokenTimezoneZ = /^(Z)$/;
var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;
/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function parse$3(argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument !== 'string') {
    return new Date(argument);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits;

  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
  } else {
    additionalDigits = Number(additionalDigits);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE;
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);
      offset = getTimezoneOffsetInMilliseconds(fullTimeDate); // Adjust time when it's coming from DST

      var fullTimeDateNextDay = new Date(fullTime);
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
      var offsetDiff = getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) - getTimezoneOffsetInMilliseconds(fullTimeDate);

      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(argument);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(parseTokenDateTimeDelimeter);
  var timeString;

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits];
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = parseTokenMM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = parseTokenDDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // YYYY-MM-DD or YYYYMMDD


  token = parseTokenMMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = parseTokenWww.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = parseTokenWwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = parseTokenHH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR;
  } // hh:mm or hhmm


  token = parseTokenHHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  } // hh:mm:ss or hhmmss


  token = parseTokenHHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function parseTimezone(timezoneString) {
  var token;
  var absoluteOffset; // Z

  token = parseTokenTimezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  } // ±hh


  token = parseTokenTimezoneHH.exec(timezoneString);

  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  } // ±hh:mm or ±hhmm


  token = parseTokenTimezoneHHMM.exec(timezoneString);

  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  }

  return 0;
}

function dayOfISOYear(isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var parse_1 = parse$3;
var parse$2 = parse_1;
/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */

function compareDesc$1(dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse$2(dirtyDateLeft);
  var timeLeft = dateLeft.getTime();
  var dateRight = parse$2(dirtyDateRight);
  var timeRight = dateRight.getTime();

  if (timeLeft > timeRight) {
    return -1;
  } else if (timeLeft < timeRight) {
    return 1;
  } else {
    return 0;
  }
}

var compare_desc = compareDesc$1;
var parse$1 = parse_1;
/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds$1(dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse$1(dirtyDateLeft);
  var dateRight = parse$1(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime();
}

var difference_in_milliseconds = differenceInMilliseconds$1;
var differenceInMilliseconds = difference_in_milliseconds;
/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds$1(dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

var difference_in_seconds = differenceInSeconds$1;

function buildDistanceInWordsLocale$1() {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },
    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },
    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },
    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },
    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },
    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },
    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },
    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },
    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },
    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },
    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },
    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  function localize(token, count, options) {
    options = options || {};
    var result;

    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }

    return result;
  }

  return {
    localize: localize
  };
}

var build_distance_in_words_locale = buildDistanceInWordsLocale$1;
var commonFormatterKeys = ['M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd', 'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG', 'H', 'HH', 'h', 'hh', 'm', 'mm', 's', 'ss', 'S', 'SS', 'SSS', 'Z', 'ZZ', 'X', 'x'];

function buildFormattingTokensRegExp$1(formatters) {
  var formatterKeys = [];

  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key);
    }
  }

  var formattingTokens = commonFormatterKeys.concat(formatterKeys).sort().reverse();
  var formattingTokensRegExp = new RegExp('(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g');
  return formattingTokensRegExp;
}

var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp$1;
var buildFormattingTokensRegExp = build_formatting_tokens_reg_exp;

function buildFormatLocale$1() {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];
  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function MMM(date) {
      return months3char[date.getMonth()];
    },
    // Month: January, February, ..., December
    'MMMM': function MMMM(date) {
      return monthsFull[date.getMonth()];
    },
    // Day of week: Su, Mo, ..., Sa
    'dd': function dd(date) {
      return weekdays2char[date.getDay()];
    },
    // Day of week: Sun, Mon, ..., Sat
    'ddd': function ddd(date) {
      return weekdays3char[date.getDay()];
    },
    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function dddd(date) {
      return weekdaysFull[date.getDay()];
    },
    // AM, PM
    'A': function A(date) {
      return date.getHours() / 12 >= 1 ? meridiemUppercase[1] : meridiemUppercase[0];
    },
    // am, pm
    'a': function a(date) {
      return date.getHours() / 12 >= 1 ? meridiemLowercase[1] : meridiemLowercase[0];
    },
    // a.m., p.m.
    'aa': function aa(date) {
      return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0];
    }
  }; // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.

  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date));
    };
  });
  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  };
}

function ordinal(number) {
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var build_format_locale = buildFormatLocale$1;
var buildDistanceInWordsLocale = build_distance_in_words_locale;
var buildFormatLocale = build_format_locale;
/**
 * @category Locales
 * @summary English locale.
 */

var en = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
};
var compareDesc = compare_desc;
var parse = parse_1;
var differenceInSeconds = difference_in_seconds;
var enLocale = en;
var MINUTES_IN_DAY = 1440;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_YEAR = 525600;
/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */

function distanceInWordsStrict(dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {};
  var comparison = compareDesc(dirtyDateToCompare, dirtyDate);
  var locale = options.locale;
  var localize = enLocale.distanceInWords.localize;

  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize;
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  };
  var dateLeft, dateRight;

  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare);
    dateRight = parse(dirtyDate);
  } else {
    dateLeft = parse(dirtyDate);
    dateRight = parse(dirtyDateToCompare);
  }

  var unit;
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor'];
  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset();
  var minutes = mathPartial(seconds / 60) - offset;
  var hours, days, months, years;

  if (options.unit) {
    unit = String(options.unit);
  } else {
    if (minutes < 1) {
      unit = 's';
    } else if (minutes < 60) {
      unit = 'm';
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h';
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd';
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M';
    } else {
      unit = 'Y';
    }
  } // 0 up to 60 seconds


  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60);
    return localize('xHours', hours, localizeOptions); // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY);
    return localize('xDays', days, localizeOptions); // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH);
    return localize('xMonths', months, localizeOptions); // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR);
    return localize('xYears', years, localizeOptions);
  }

  throw new Error('Unknown unit: ' + unit);
}

var distance_in_words_strict = distanceInWordsStrict;

var apiGetActivity = function apiGetActivity() {
  return api.apiClient.get('v3/me/activity_feed_items/pending');
};

var apiMarkActivityAsRead = function apiMarkActivityAsRead(id) {
  return api.apiClient.post("v3/me/activity_feed_items/".concat(id, "/mark_read"));
};

var apiMarkAllActivitiesAsRead = function apiMarkAllActivitiesAsRead() {
  return api.apiClient.post("v3/me/activity_feed_items/mark_feed_read");
};

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn__default["default"](this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ActivityItem =
/*#__PURE__*/
function (_Component) {
  _inherits__default["default"](ActivityItem, _Component);

  var _super = _createSuper(ActivityItem);

  function ActivityItem() {
    _classCallCheck__default["default"](this, ActivityItem);

    return _super.apply(this, arguments);
  }

  _createClass__default["default"](ActivityItem, [{
    key: "links",
    value: function links(type) {
      var activity = this.props.activity;
      var urls = {
        CommentApproved: "/works/".concat(activity.activity_object.id),
        WorkPublished: "/works/".concat(activity.activity_object.id),
        SchoolFollowed: "/schools/".concat(activity.activity_object.id),
        SchoolUnfollowed: "/schools/".concat(activity.activity_object.id),
        PresentationShared: "/lessons/shared/".concat(activity.activity_object.id),
        ParentAddedToStudent: "/student/".concat(activity.activity_object.id),
        GuestModeratorInvited: "/moderation/assessment-files/".concat(activity.activity_object.assessment_file && activity.activity_object.assessment_file.id),
        ContributionMarkedAsConclusion: "/moderation/assessment-files/".concat(activity.activity_object.assessment_file && activity.activity_object.assessment_file.id),
        WorkSubmittedByStudent: "/actions/",
        PaPresentationActionCreated: "/pupil/",
        WorkApprovedByTeacher: "/pupil/",
        WorkReturnedByTeacher: "/pupil/",
        WorkSentToPeer: "/pupil/",
        WorkSentBackFromPeer: "/pupil/"
      };
      return urls[type];
    }
  }, {
    key: "toActivity",
    value: function toActivity(id, type) {
      var url = this.links(type);
      apiMarkActivityAsRead(id).then(function () {
        return window.location = url;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          activity = _this$props.activity;
      return activity &&
      /*#__PURE__*/
      React__default["default"].createElement("a", {
        href: this.links(activity.type),
        className: classes.container,
        onClick: function onClick() {
          return _this.toActivity(activity.id, activity.activity_type);
        }
      },
      /*#__PURE__*/
      React__default["default"].createElement("div", {
        className: classes.action
      },
      /*#__PURE__*/
      React__default["default"].createElement(pobbleAvatar.PobbleAvatar, {
        avatar: activity.originator.avatar,
        name: activity.originator.display_name,
        className: classes.avatar
      }),
      /*#__PURE__*/
      React__default["default"].createElement("em", null,
      /*#__PURE__*/
      React__default["default"].createElement(ActivityAction$1, {
        activity: activity
      }))),
      /*#__PURE__*/
      React__default["default"].createElement("div", {
        className: classes.timestamp
      }, distance_in_words_strict(new Date(), new Date(activity.occurred_at))));
    }
  }]);

  return ActivityItem;
}(React.Component);

var ActivityItem$1 = injectSheet__default["default"](styles)(ActivityItem);
var Activity = injectSheet__default["default"]({
  activityMenu: {
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'block',
      width: '360px',
      marginRight: '5px',
      paddingBottom: '12px'
    }
  },
  list: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    '& li': {
      '@media (max-width: 769px)': {
        padding: '0',
        border: 'none'
      }
    }
  },
  dot: {
    '@media (min-width: 769px)': {
      position: 'relative',
      margin: '0 10px 0 -10px',
      '& > a': {
        width: '46px'
      }
    },
    '& svg': {
      fontSize: '16px'
    },
    '& span:last-child': {
      '@media (min-width: 769px)': {
        display: 'none'
      }
    },
    '&:after': {
      content: '""',
      width: '8px',
      height: '8px',
      display: 'inline-block',
      background: 'var(--red)',
      position: 'absolute',
      top: '22px',
      left: '-6px',
      borderRadius: '100%',
      transform: 'scale(0)',
      '@media (min-width: 769px)': {
        top: '22px',
        left: '26px'
      }
    }
  },
  dotActive: {
    '&:after': {
      animation: '600ms cubic-bezier(0,.67,.42,2) scaleIn forwards'
    }
  },
  footer: {
    fontSize: '16px',
    color: '#a8a8a8',
    borderTop: '1px solid #ececec',
    marginTop: '10px',
    textAlign: 'center',
    '& > button': {
      padding: '32px 20px',
      width: '100%',
      textDecoration: 'none',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      color: '#a8a8a8',
      transition: 'color 300ms ease-in-out',
      '&:hover': {
        color: 'var(--blue)'
      }
    }
  },
  '@keyframes scaleIn': {
    from: {
      tranform: 'scale(0)'
    },
    to: {
      transform: 'scale(1)'
    }
  }
})(function (_ref) {
  var classes = _ref.classes,
      activePage = _ref.activePage,
      appUrl = _ref.appUrl;

  var _useState = React.useState([]),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var activities = data && data.slice(0, 3).map(function (activity, index) {
    return (
      /*#__PURE__*/
      React__default["default"].createElement(ActivityItem$1, {
        key: index,
        activity: activity
      })
    );
  });
  var count = data && data.length;
  React.useEffect(function () {
    apiGetActivity().then(function (_ref2) {
      var data = _ref2.data;
      return setData(data.activity_feed_items);
    });
  }, []);

  var toActivities = function toActivities(e) {
    e && e.preventDefault();
    apiMarkAllActivitiesAsRead().then(function () {
      return window.location = '/activity';
    });
  };

  return (
    /*#__PURE__*/
    React__default["default"].createElement(DropMenu, {
      className: classes.container
    }, function (Container, Menu) {
      return (
        /*#__PURE__*/
        React__default["default"].createElement(Container, null,
        /*#__PURE__*/
        React__default["default"].createElement("ul", {
          className: classes.list
        },
        /*#__PURE__*/
        React__default["default"].createElement(NavItem, {
          active: activePage === 'activity',
          url: "".concat(appUrl, "/activity/"),
          icon:
          /*#__PURE__*/
          React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
            icon: faBell.faBell
          }),
          className: classNames__default["default"](classes.dot, _defineProperty__default["default"]({}, classes.dotActive, !!count)),
          onClick: toActivities
        }, "Activity")), !!count &&
        /*#__PURE__*/
        React__default["default"].createElement(Menu, {
          className: classes.activityMenu
        },
        /*#__PURE__*/
        React__default["default"].createElement(ActivityHeader$1, {
          count: count
        }),
        /*#__PURE__*/
        React__default["default"].createElement("div", null, activities), count > 3 &&
        /*#__PURE__*/
        React__default["default"].createElement("div", {
          className: classes.footer
        },
        /*#__PURE__*/
        React__default["default"].createElement(Button__default["default"], {
          simple: true,
          action: function action() {
            return toActivities();
          }
        }, "View all"))))
      );
    })
  );
});
var HeaderMenuBox = injectSheet__default["default"]({
  container: {
    '@media (min-width: 769px)': {
      padding: '26px',
      borderTop: '1px solid #ececec',
      '&:first-child': {
        borderTop: 'none'
      }
    }
  },
  title: {
    margin: '0',
    color: '#777',
    fontSize: '14px',
    lineHeight: '14px'
  },
  menu: {
    listStyle: 'none',
    padding: '0',
    margin: '0'
  }
})(function (_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.container, className)
    }, title &&
    /*#__PURE__*/
    React__default["default"].createElement("h5", {
      className: classes.title
    }, title),
    /*#__PURE__*/
    React__default["default"].createElement("ul", {
      className: classes.menu
    }, children))
  );
});

var stripEndSlash = function stripEndSlash(str) {
  return str[str.length - 1] === '/' ? str.slice(0, str.length - 1) : str;
};

var isInActiveState = function isInActiveState(url) {
  return stripEndSlash(window.location.href) === stripEndSlash(url);
};

var HeaderMenuLink = injectSheet__default["default"]({
  item: {
    '@media (min-width: 769px)': {
      marginTop: '16px',
      lineHeight: '1.2',
      '&:first-child': {
        marginTop: '0'
      }
    }
  },
  premium: {
    '& $link': {
      color: 'var(--gray---)'
    }
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: 'var(--gray)',
    '@media (max-width: 768px)': {
      padding: '4px 0',
      margin: '2px 0'
    },
    '@media (min-width: 769px)': {
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'color 0.3s',
      '&:hover': {
        color: 'var(--blue)'
      }
    }
  },
  active: {
    color: 'var(--blue)'
  },
  premiumIcon: {
    color: 'var(--gray---)',
    fontSize: '.7em',
    marginRight: '.5em'
  }
})(function (_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      href = _ref.href,
      target = _ref.target,
      className = _ref.className,
      schoolRequired = _ref.schoolRequired,
      _ref$subscriptionPoli = _ref.subscriptionPolicy,
      subscriptionPolicy = _ref$subscriptionPoli === void 0 ? function () {
    return {
      restricted: false,
      plan: 'pobble-bronze'
    };
  } : _ref$subscriptionPoli;

  var _useState = React.useState(isInActiveState(href)),
      _useState2 = _slicedToArray__default["default"](_useState, 1),
      active = _useState2[0];

  var SP = subscriptions.useSubscriptionPolicy(subscriptionPolicy);

  var _useMe = pobbleUser.useMe(),
      me = _useMe.me,
      showSchoolRequiredDialog = _useMe.showSchoolRequiredDialog;

  var hasSchool = me.account.policy.teacher_in_school;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("li", {
      className: classNames__default["default"](classes.item, _defineProperty__default["default"]({}, classes.premium, SP.restricted))
    },
    /*#__PURE__*/
    React__default["default"].createElement("a", {
      href: href,
      target: target,
      onClick: function onClick(e) {
        if (SP.restricted) {
          e.preventDefault();
          SP.showDialog();
        } else if (schoolRequired && !hasSchool) {
          e.preventDefault();
          showSchoolRequiredDialog();
        }
      },
      className: classNames__default["default"](classes.link, className, _defineProperty__default["default"]({}, classes.active, active))
    }, SP.restricted &&
    /*#__PURE__*/
    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      className: classes.premiumIcon,
      icon: faCrown.faCrown
    }), children))
  );
});
var AuthorisedMenu = injectSheet__default["default"]({
  container: {
    '@media (min-width: 769px)': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  list: {
    '@media (min-width: 769px)': {
      marginRight: '20px',
      display: 'flex',
      alignItems: 'center'
    },
    listStyle: 'none',
    margin: '0',
    padding: '0'
  },
  helpLink: {
    color: 'var(--blue)'
  },
  desktopAvatar: {
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '4px',
      fontSize: '11px'
    }
  },
  desktopProfileInfo: {
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'block'
    }
  },
  mobileProfileIcon: {
    display: 'none',
    maxWidth: '14px'
  },
  mobileAvatarContainer: {
    display: 'flex',
    width: '100%',
    borderBottom: '1px solid #ececec',
    paddingBottom: '20px',
    marginBottom: '20px',
    '@media (min-width: 769px)': {
      display: 'none'
    }
  },
  mobileAvatar: {
    width: '60px',
    height: '60px',
    margin: '0 12px 0 0',
    '& > *': {
      fontSize: '60px !important'
    }
  },
  mobileUserName: {
    color: '#777',
    fontSize: '22px',
    lineHeight: '1',
    margin: '0',
    fontWeight: 'normal'
  },
  mobileUserProfileLink: {
    color: '#00aeef',
    fontSize: '14px',
    lineHeight: '1.5',
    textDecoration: 'none'
  },
  mobileAvatarDesc: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  upgrade: {
    '& svg': {
      color: '#fee433',
      fontSize: '.7em',
      marginRight: '.5em'
    }
  },
  featureRequest: {
    '& a > span:first-child': {
      color: 'var(--yellow)',
      opacity: '1'
    }
  }
})(function (_ref) {
  var classes = _ref.classes;

  var _useContext = React.useContext(HeaderContext),
      activePage = _useContext.activePage,
      me = _useContext.me,
      appUrl = _useContext.appUrl;

  var isStudent = me.account.student_type;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.container
    },
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.mobileAvatarContainer
    },
    /*#__PURE__*/
    React__default["default"].createElement(Avatar$1, {
      className: classes.mobileAvatar
    }),
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.mobileAvatarDesc
    },
    /*#__PURE__*/
    React__default["default"].createElement("h5", {
      className: classes.mobileUserName
    }, me.account.display_name))),
    /*#__PURE__*/
    React__default["default"].createElement("ul", {
      className: classes.list
    }, isStudent &&
    /*#__PURE__*/
    React__default["default"].createElement(React.Fragment, null,
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      active: activePage === 'home',
      url: "".concat(appUrl, "/"),
      Icon: faGlobe.faGlobe
    }, "Writing Bank"), me.account.policy.can_see_pupil_lessons &&
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      active: activePage === 'pupil',
      url: "".concat(appUrl, "/pupil"),
      Icon: faChalkboard.faChalkboard
    }, "Lessons")), !isStudent &&
    /*#__PURE__*/
    React__default["default"].createElement(React.Fragment, null,
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      active: activePage === 'prompts',
      icon:
      /*#__PURE__*/
      React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faFeather.faFeather
      }),
      subscriptionPolicy: function subscriptionPolicy(sp) {
        return sp.moderation.basic_moderation;
      },
      url: "/lessons/prompt"
    }, "Writing prompts"),
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      linkClassName: "metrics__header_nav_resources",
      active: activePage === 'resources',
      icon:
      /*#__PURE__*/
      React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faSearch.faSearch
      }),
      subscriptionPolicy: function subscriptionPolicy(sp) {
        return sp.moderation.basic_moderation;
      },
      url: "/lessons/discover"
    }, "Resources"),
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      active: activePage === 'moderation',
      icon:
      /*#__PURE__*/
      React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faFileCheck.faFileCheck
      }),
      subscriptionPolicy: function subscriptionPolicy(sp) {
        return sp.moderation.basic_moderation;
      },
      url: "".concat(setup.URLS.MODERATION)
    }, "Moderation"),
    /*#__PURE__*/
    React__default["default"].createElement(DropMenu, null, function (Container, Menu) {
      return (
        /*#__PURE__*/
        React__default["default"].createElement(Container, {
          className: classes.expandable
        },
        /*#__PURE__*/
        React__default["default"].createElement(NavItem, {
          active: activePage === 'dashboard' || activePage === 'actions' || activePage === 'pobble-app',
          icon:
          /*#__PURE__*/
          React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
            icon: faSchool.faSchool
          }),
          expandable: true
        }, "My School"),
        /*#__PURE__*/
        React__default["default"].createElement(Menu, null,
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuBox, null,
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          schoolRequired: true,
          href: "".concat(setup.URLS.APP, "/schools/my-school")
        }, "School celebration page"),
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          schoolRequired: true,
          href: setup.URLS.ACTIONS
        }, "Work upload / review"),
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          schoolRequired: true,
          href: setup.URLS.DASHBOARD
        }, "Manage pupils"))))
      );
    }),
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      className: "".concat(classes.featureRequest, " metrics__feature_request"),
      icon:
      /*#__PURE__*/
      React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faLightbulbOn.faLightbulbOn
      })
    }, "What's missing?"))), me.account.policy.can_see_activity_link && me.account.finish_signup_status.finished &&
    /*#__PURE__*/
    React__default["default"].createElement(Activity, {
      activePage: activePage,
      appUrl: appUrl
    }),
    /*#__PURE__*/
    React__default["default"].createElement(DropMenu, null, function (Container, Menu) {
      return (
        /*#__PURE__*/
        React__default["default"].createElement(Container, {
          className: classes.profileContainer
        },
        /*#__PURE__*/
        React__default["default"].createElement("div", {
          className: classes.desktopAvatar
        },
        /*#__PURE__*/
        React__default["default"].createElement(Avatar$1, {
          circles: true
        }),
        /*#__PURE__*/
        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faCaretDown.faCaretDown
        })),
        /*#__PURE__*/
        React__default["default"].createElement(Menu, {
          className: classes.profileMenu
        },
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuBox, {
          className: classes.desktopProfileInfo,
          title: me.account.display_name
        }),
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuBox, {
          className: classes.profileHelpBox
        }, me.account.policy.can_see_profile_link &&
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          href: setup.URLS.ACCOUNT
        },
        /*#__PURE__*/
        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faUser.faUser,
          className: classes.mobileProfileIcon
        }), "My account"), me.account.policy.can_see_subscriptions &&
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          href: "".concat(setup.URLS.ACCOUNT, "/membership?from=navigation")
        }, "My subscription"), me.account.policy.view_school_tab &&
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          active: activePage === 'schools',
          href: "".concat(appUrl, "/account/school/")
        },
        /*#__PURE__*/
        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faSchool.faSchool,
          className: classes.mobileProfileIcon
        }), "School settings"),
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          target: "_blank",
          href: "https://help.pobble.com/knowledge"
        }, "Support")),
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuBox, {
          className: classes.profileSignoutBox
        },
        /*#__PURE__*/
        React__default["default"].createElement(HeaderMenuLink, {
          href: "".concat(appUrl, "/auth/sign-out/")
        },
        /*#__PURE__*/
        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: faSignOut.faSignOut,
          className: classes.mobileProfileIcon
        }), "Sign out"))))
      );
    }))
  );
});
var AuthorisedMenu$1 =
/*#__PURE__*/
React.memo(AuthorisedMenu);
var UnauthorisedMenu = injectSheet__default["default"]({
  list: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '@media (min-width: 769px)': {
      display: 'flex'
    }
  },
  signIn: {
    background: 'rgba(255, 255, 255, 0.1)'
  }
})(function (_ref) {
  var classes = _ref.classes;

  var _useContext = React.useContext(HeaderContext),
      appUrl = _useContext.appUrl;

  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", null,
    /*#__PURE__*/
    React__default["default"].createElement("ul", {
      className: classes.list
    },
    /*#__PURE__*/
    React__default["default"].createElement(NavItem, {
      className: classes.signIn,
      icon:
      /*#__PURE__*/
      React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: faUser.faUser
      }),
      url: "".concat(appUrl, "/auth/")
    }, "Sign in to my account")))
  );
});
var bodyScrollLock_min = {};

(function (exports) {
  !function (e, t) {
    t(exports);
  }(commonjsGlobal, function (exports) {
    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, o = Array(e.length); t < e.length; t++) o[t] = e[t];

        return o;
      }

      return Array.from(e);
    }

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var l = !1;

    if ("undefined" != typeof window) {
      var e = {
        get passive() {
          l = !0;
        }

      };
      window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
    }

    var d = "undefined" != typeof window && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform),
        c = [],
        u = !1,
        a = -1,
        s = void 0,
        v = void 0,
        f = function f(t) {
      return c.some(function (e) {
        return !(!e.options.allowTouchMove || !e.options.allowTouchMove(t));
      });
    },
        m = function m(e) {
      var t = e || window.event;
      return !!f(t.target) || 1 < t.touches.length || (t.preventDefault && t.preventDefault(), !1);
    },
        o = function o() {
      setTimeout(function () {
        void 0 !== v && (document.body.style.paddingRight = v, v = void 0), void 0 !== s && (document.body.style.overflow = s, s = void 0);
      });
    };

    exports.disableBodyScroll = function (i, e) {
      if (d) {
        if (!i) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");

        if (i && !c.some(function (e) {
          return e.targetElement === i;
        })) {
          var t = {
            targetElement: i,
            options: e || {}
          };
          c = [].concat(r(c), [t]), i.ontouchstart = function (e) {
            1 === e.targetTouches.length && (a = e.targetTouches[0].clientY);
          }, i.ontouchmove = function (e) {
            var t, o, n, r;
            1 === e.targetTouches.length && (o = i, r = (t = e).targetTouches[0].clientY - a, !f(t.target) && (o && 0 === o.scrollTop && 0 < r ? m(t) : (n = o) && n.scrollHeight - n.scrollTop <= n.clientHeight && r < 0 ? m(t) : t.stopPropagation()));
          }, u || (document.addEventListener("touchmove", m, l ? {
            passive: !1
          } : void 0), u = !0);
        }
      } else {
        n = e, setTimeout(function () {
          if (void 0 === v) {
            var e = !!n && !0 === n.reserveScrollBarGap,
                t = window.innerWidth - document.documentElement.clientWidth;
            e && 0 < t && (v = document.body.style.paddingRight, document.body.style.paddingRight = t + "px");
          }

          void 0 === s && (s = document.body.style.overflow, document.body.style.overflow = "hidden");
        });
        var o = {
          targetElement: i,
          options: e || {}
        };
        c = [].concat(r(c), [o]);
      }

      var n;
    }, exports.clearAllBodyScrollLocks = function () {
      d ? (c.forEach(function (e) {
        e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null;
      }), u && (document.removeEventListener("touchmove", m, l ? {
        passive: !1
      } : void 0), u = !1), c = [], a = -1) : (o(), c = []);
    }, exports.enableBodyScroll = function (t) {
      if (d) {
        if (!t) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        t.ontouchstart = null, t.ontouchmove = null, c = c.filter(function (e) {
          return e.targetElement !== t;
        }), u && 0 === c.length && (document.removeEventListener("touchmove", m, l ? {
          passive: !1
        } : void 0), u = !1);
      } else 1 === c.length && c[0].targetElement === t ? (o(), c = []) : c = c.filter(function (e) {
        return e.targetElement !== t;
      });
    };
  });
})(bodyScrollLock_min);

var bodyScrollLock =
/*@__PURE__*/
getDefaultExportFromCjs(bodyScrollLock_min);

var Nav = function Nav(_ref) {
  var classes = _ref.classes;

  var _useContext = React.useContext(HeaderContext),
      className = _useContext.className,
      authorised = _useContext.authorised;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      menuOpened = _useState2[0],
      setMenuOpened = _useState2[1];

  var menuRef = React.useRef(null);

  var toggleMenu = function toggleMenu() {
    menuOpened ? bodyScrollLock.enableBodyScroll(menuRef.current) : bodyScrollLock.disableBodyScroll(menuRef.current);
    setMenuOpened(!menuOpened);
  };

  return (
    /*#__PURE__*/
    React__default["default"].createElement("nav", {
      className: classNames__default["default"](classes.container, className)
    },
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      onClick: toggleMenu,
      className: classes.toggleMobileMenu
    },
    /*#__PURE__*/
    React__default["default"].createElement(BurgerButton$1, {
      opened: menuOpened
    }), " Menu"),
    /*#__PURE__*/
    React__default["default"].createElement("span", {
      className: classNames__default["default"](classes.mobileOverlay, _defineProperty__default["default"]({}, classes.mobileOverlayShown, menuOpened))
    }),
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      ref: menuRef,
      className: classNames__default["default"](classes.menuHolder, _defineProperty__default["default"]({}, classes.menuHolderOpened, menuOpened))
    }, authorised &&
    /*#__PURE__*/
    React__default["default"].createElement(AuthorisedMenu$1, null), !authorised &&
    /*#__PURE__*/
    React__default["default"].createElement(UnauthorisedMenu, null)))
  );
};

var Nav$1 = injectSheet__default["default"](styles$5)(Nav);

var Header$1 = function Header(_ref) {
  var classes = _ref.classes;

  var _useContext = React.useContext(HeaderContext),
      className = _useContext.className,
      pending = _useContext.pending,
      me = _useContext.me,
      style = _useContext.style,
      student = _useContext.student;

  var isStudent = React.useMemo(function () {
    return me && me.account && me.account.student_type;
  }, [me]);
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.container, className, _defineProperty__default["default"]({}, classes.studentHeader, student || isStudent)),
      style: style
    },
    /*#__PURE__*/
    React__default["default"].createElement("a", {
      className: classes.logo,
      href: isStudent ? setup.URLS.PUPIL_ACTIVITIES : '/lessons/prompt'
    },
    /*#__PURE__*/
    React__default["default"].createElement("img", {
      className: classes.logoIcon,
      src: "https://app.pobble.com/account/files/logo-white.svg"
    })), !pending &&
    /*#__PURE__*/
    React__default["default"].createElement(Nav$1, {
      me: me,
      className: classes.nav
    }))
  );
};

var Header$2 = injectSheet__default["default"](styles$6)(Header$1);

var HeaderContainer = function HeaderContainer(_ref) {
  var me = _ref.me,
      meRequest = _ref.meRequest,
      activePage = _ref.activePage,
      _ref$appUrl = _ref.appUrl,
      appUrl = _ref$appUrl === void 0 ? '' : _ref$appUrl,
      className = _ref.className,
      style = _ref.style,
      student = _ref.student;
  var value = React.useMemo(function () {
    return {
      authorised: !meRequest.pending && me,
      pending: meRequest.pending,
      me: me,
      activePage: activePage,
      appUrl: appUrl,
      className: className,
      style: style,
      student: student
    };
  }, [me, meRequest, activePage, appUrl, style, student, className]);
  return (
    /*#__PURE__*/
    React__default["default"].createElement(HeaderContext.Provider, {
      value: value
    },
    /*#__PURE__*/
    React__default["default"].createElement(Header$2, null))
  );
};

HeaderContainer.propTypes = {
  /**
   * Base url of pobble app
   * Will be used as a prefix to all header links
   * Will fallback to empty string if not set, making all links relative to the domain.
   * Empty string fallback is useful for proxy SPAs that are located under the same domain.
   * Example value: https://stg-app.pobble.com
   */
  appUrl: PropTypes__default["default"].string,

  /**
   * Currently active page
   */
  activePage: PropTypes__default["default"].string,

  /**
   * Additional header classname for repositiong
   */
  className: PropTypes__default["default"].string
};
var Header = pobbleUser.withMe(HeaderContainer);
module.exports = Header;